export default __webpack_public_path__ + "static/media/volunteer1.cfa35189.jpg";